import { useQuery } from "@apollo/client";
import { GET_PARTICIPATION_DETAIL } from "../api/participation";

export const useParticipation = (participationId: number) => {
  const { data, loading, error, refetch } = useQuery(GET_PARTICIPATION_DETAIL, {
    variables: { participationId },
    fetchPolicy: "cache-and-network",
    skip: !participationId,
  });

  return {
    participation: data?.participation,
    loading,
    error,
    refetch,
  };
};
